// FeaturedProductCard.js
import React from 'react';
import './FeaturedProductCard.css';

const FeaturedProductCard = ({ name, image, url }) => {
  return (
    <a href={url} className="featured-product-card" target="_blank" rel="noopener noreferrer">
      <div className="featured-product-image-container">
        <img src={image} alt={`Product showcase of ${name}`} className="featured-product-image" />
      </div>
      <div className="featured-product-name">{name}</div>
    </a>
  );
};

export default FeaturedProductCard;